<template>
  <div class="products-list">
    <h3
      class="text-color-navy general__block-title text-h5"
      v-html="$t('product.admetox.productsTitle')"
    />
    <div
      :class="{
        'products-list__container--active': isSkuBlockOutlined,
        'products-list__container--highlight': isSkuBlockHighlighted,
      }"
      class="products-list__container"
    >
      <div class="products-list__items">
        <div v-if="skuProducts.length" class="products-list__items-container">
          <label
            v-for="(productSku, n) in skuProducts"
            :key="`${productSku.code}-${n}`"
            class="radio-button products-list__label"
            :class="{
              'products-list__label--active': activeSku.code === productSku.code ? 'checked' : null,
            }"
          >
            <input
              type="radio"
              name="product"
              class="radio-button__input"
              :value="productSku.code"
              :checked="activeSku.code === productSku.code"
              @change="$emit('skuSelected', productSku.code)"
            />
            <span
              class="products-list__sku products-list__text text-description"
              v-html="productSku.code"
            />
            <span
              class="products-list__title products-list__text text-description"
              v-html="productSku.name"
            />
          </label>
        </div>
        <div
          v-if="!skuProducts.length && !hasBaseSku"
          class="products-list__error"
          v-html="noBaseSkuErrorCopy"
        />
      </div>
    </div>
    <app-button
      v-if="isInventoryButtonVisible"
      :text="$t('product.inventoryBtn')"
      type="button"
      size="middle"
      class="general__inventory-btn"
      @clicked="$emit('inventoryButtonClicked')"
    />
  </div>
</template>
<script>
import { useContentfulComponent } from '@/components/common/contentful/composables/useContentfulComponent'
export default {
  name: 'ProductDetailsSkuList',
  props: {
    skuProducts: {
      type: Array,
      required: true,
    },
    activeSku: {
      type: Object,
      required: true,
    },
    isSkuBlockOutlined: {
      type: Boolean,
      required: true,
    },
    isSkuBlockHighlighted: {
      type: Boolean,
      required: true,
    },
    isInventoryButtonVisible: {
      type: Boolean,
      required: true,
    },
    hasBaseSku: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['skuSelected', 'inventoryButtonClicked'],
  setup() {
    const { getSiteCopy } = useContentfulComponent()

    return {
      getSiteCopy,
    }
  },
  computed: {
    noBaseSkuErrorCopy() {
      return this.getSiteCopy('copyGroupProductDetailsPage', 'copyItemNoCustomSKUError ') || ''
    },
  },
}
</script>
